import { createDateObject } from '../../../Helpers/dateFormatter';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import SettingsProductsAndSubscriptionsQuery from './SettingsProductsAndSubscriptionsQuery';

const SettingsProductsAndSubscriptionsConnectorApollo = ({ children }) => {
  const { loading, data } = useQuery(SettingsProductsAndSubscriptionsQuery);
  const result = {
    loading,
  };
  if (!loading) {
    const { diet, videoWorkout, activeSubscriptions: subscriptions } = data.me;
    result.dietAccessTo = createDateObject(diet.accessTo);
    result.dietLifetimeAccess = diet.lifetimeAccess;
    result.videoWorkoutAccessTo = createDateObject(videoWorkout.accessTo);
    result.videoWorkoutLifetimeAccess = videoWorkout.lifetimeAccess;
    result.subscriptions = subscriptions.map((sub) => ({
      givesAccessToDiet: sub.givesAccessToDiet,
      givesAccessToVideoWorkouts: sub.givesAccessToVideoWorkouts,
      renewalDate: createDateObject(sub.renewalDate),
      operator: sub.operator,
    }));
  }
  return children(result);
};

SettingsProductsAndSubscriptionsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default SettingsProductsAndSubscriptionsConnectorApollo;
